<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="6" xl="6">
                <transition name="slide">
                    <b-card v-if="model">
                        <b-form-group
                            :label="this.$t('action')"
                            :label-cols="12"
                            :horizontal="false">
                                 <b-form-input type="text" v-model.number="model.action" disabled></b-form-input>
                        </b-form-group>

                        <b-form-group
                            :label="this.$t('createdAt')"
                            :label-cols="12"
                            :horizontal="false">
                                 <b-form-input type="text" v-model.number="model.created_at" disabled></b-form-input>
                        </b-form-group>
                    </b-card>
                </transition>
            </b-col>
            <b-col cols="6" xl="6">
                <transition name="slide">
                    <b-card v-if="model">
                        <pre>{{ JSON.stringify(model.data, null, 4) }}</pre>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
    name: "Edit",
    data: function() {
        return {}
    },
    computed: {
        model() {
            return this.$store.getters.event(this.$route.params.id)
        }
    },

    mounted() {
        if (!this.$can("inspect base_events")) {
            this.$router.back()
        }
    }
}
</script>
